<template>
	<section id="revit-banner" class="checklist mt-30">
		<div class="checkbox checkbox--small checkbox--disabled mb-20">
			<input type="checkbox" class="checkbox__input" checked>
			<span class="checkbox__label light-font-color" style="--start: var(--disabled);--main-font: var(--disabled);">Проставляйте галочки после выполнения каждого практического задания</span>
		</div>

		<h2 class="checklist__title">1. Подготовительный этап (до прихода сотрудника)</h2>
		<div class="checklist__list">
			<h3 class="checklist__subtitle">Подготовка рабочего места</h3>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-1-1" v-model="edusonChecklist">
				<span class="checkbox__label">Рабочее место подготовлено</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-1-2" v-model="edusonChecklist">
				<span class="checkbox__label">Ноутбук настроен и готов к работе</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-1-3" v-model="edusonChecklist">
				<span class="checkbox__label">Получен служебный номер</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-1-4" v-model="edusonChecklist">
				<span class="checkbox__label">Подготовлены необходимые доступы и учетные записи</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-1-5" v-model="edusonChecklist">
				<span class="checkbox__label">Подготовлены канцелярские принадлежности</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-1-6" v-model="edusonChecklist">
				<span class="checkbox__label">Подготовлена прокси-карта и необходимые доступы</span>
			</label>
		</div>
		<div class="checklist__list">
			<h3 class="checklist__subtitle">Организационная подготовка</h3>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-1-7" v-model="edusonChecklist">
				<span class="checkbox__label">Команда проинформирована о выходе нового сотрудника</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-1-8" v-model="edusonChecklist">
				<span class="checkbox__label">Подготовлено краткое представление сотрудника для команды</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-1-9" v-model="edusonChecklist">
				<span class="checkbox__label">Проверено прохождение обязательных инструктажей (ТБ, СБ, ИБ)</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-1-10" v-model="edusonChecklist">
				<span class="checkbox__label">Согласован план первого рабочего дня</span>
			</label>
		</div>

		<h2 class="checklist__title">2. Первый рабочий день</h2>
		<div class="checklist__list">
			<h3 class="checklist__subtitle">Встреча сотрудника</h3>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-2-1" v-model="edusonChecklist">
				<span class="checkbox__label">Встреча сотрудника на первом этаже</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-2-2" v-model="edusonChecklist">
				<span class="checkbox__label">Представление себя в роли куратора</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-2-3" v-model="edusonChecklist">
				<span class="checkbox__label">Разъяснение своей роли и порядка взаимодействия</span>
			</label>
		</div>
		<div class="checklist__list">
			<h3 class="checklist__subtitle">Знакомство с Компанией</h3>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-2-4" v-model="edusonChecklist">
				<span class="checkbox__label">Проведена экскурсия по офису</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-2-5" v-model="edusonChecklist">
				<span class="checkbox__label">Показаны основные рабочие зоны</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-2-6" v-model="edusonChecklist">
				<span class="checkbox__label">Показаны зоны отдыха, столовая, переговорные комнаты</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-2-7" v-model="edusonChecklist">
				<span class="checkbox__label">Представлены сотрудники подразделения</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-2-8" v-model="edusonChecklist">
				<span class="checkbox__label">Представлены ключевые сотрудники смежных подразделений</span>
			</label>
		</div>
		<div class="checklist__list">
			<h3 class="checklist__subtitle">Знакомство с корпоративной культурой</h3>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-2-9" v-model="edusonChecklist">
				<span class="checkbox__label">Рассказано о ценностях Компании</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-2-10" v-model="edusonChecklist">
				<span class="checkbox__label">Рассказано о корпоративных традициях</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-2-11" v-model="edusonChecklist">
				<span class="checkbox__label">Рассказано о корпоративных мероприятиях и инициативах</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-2-12" v-model="edusonChecklist">
				<span class="checkbox__label">Ознакомление с правилами внутреннего распорядка</span>
			</label>
		</div>
		<div class="checklist__list">
			<h3 class="checklist__subtitle">Кадровые вопросы</h3>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-2-13" v-model="edusonChecklist">
				<span class="checkbox__label">Организовано знакомство со Службой по работе с персоналом</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-2-14" v-model="edusonChecklist">
				<span class="checkbox__label">Разъяснено, по каким вопросам можно обращаться в HR</span>
			</label>
		</div>

		<h2 class="checklist__title">3. Второй рабочий день</h2>
		<div class="checklist__list">
			<h3 class="checklist__subtitle">Полезные сервисы Компании</h3>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-3-1" v-model="edusonChecklist">
				<span class="checkbox__label">Ознакомление с ECM</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-3-2" v-model="edusonChecklist">
				<span class="checkbox__label">Ознакомление с Connect</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-3-3" v-model="edusonChecklist">
				<span class="checkbox__label">Ознакомление с O!Life</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-3-4" v-model="edusonChecklist">
				<span class="checkbox__label">Ознакомление с HR-ботом</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-3-5" v-model="edusonChecklist">
				<span class="checkbox__label">Ознакомление с O!Coin</span>
			</label>
		</div>
		<div class="checklist__list">
			<h3 class="checklist__subtitle">Проверка адаптации</h3>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-3-6" v-model="edusonChecklist">
				<span class="checkbox__label">Получена первая обратная связь от сотрудника</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-3-7" v-model="edusonChecklist">
				<span class="checkbox__label">Выявлены возникающие вопросы или сложности</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-3-8" v-model="edusonChecklist">
				<span class="checkbox__label">Предоставлены необходимые разъяснения</span>
			</label>
		</div>

		<h2 class="checklist__title">4. Первая неделя</h2>
		<div class="checklist__list">
			<h3 class="checklist__subtitle">Интеграция в коллектив</h3>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-4-1" v-model="edusonChecklist">
				<span class="checkbox__label">Организовано неформальное знакомство с коллегами</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-4-2" v-model="edusonChecklist">
				<span class="checkbox__label">Сотрудник включен во внутренние коммуникации команды</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-4-3" v-model="edusonChecklist">
				<span class="checkbox__label">Разъяснены негласные правила и особенности взаимодействия в подразделении</span>
			</label>
		</div>
		<div class="checklist__list">
			<h3 class="checklist__subtitle">Сопровождение сотрудника</h3>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-4-4" v-model="edusonChecklist">
				<span class="checkbox__label">Проведены регулярные короткие встречи</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-4-5" v-model="edusonChecklist">
				<span class="checkbox__label">Получена обратная связь по первым впечатлениям</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-4-6" v-model="edusonChecklist">
				<span class="checkbox__label">Оказана помощь в решении организационных вопросов</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-4-7" v-model="edusonChecklist">
				<span class="checkbox__label">Проверена обеспеченность всеми необходимыми доступами и ресурсами</span>
			</label>
		</div>

		<h2 class="checklist__title">5. Вторая–третья недели</h2>
		<div class="checklist__list">
			<h3 class="checklist__subtitle">Контроль процесса адаптации</h3>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-5-1" v-model="edusonChecklist">
				<span class="checkbox__label">Проведена встреча с сотрудником</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-5-2" v-model="edusonChecklist">
				<span class="checkbox__label">Обсужден уровень комфортности в коллективе</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-5-3" v-model="edusonChecklist">
				<span class="checkbox__label">Обсуждены возникающие сложности</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-5-4" v-model="edusonChecklist">
				<span class="checkbox__label">Предоставлена помощь в установлении взаимодействия со смежными подразделениями</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-5-5" v-model="edusonChecklist">
				<span class="checkbox__label">Предоставлена информация о корпоративных возможностях и мероприятиях Компании</span>
			</label>
		</div>

		<h2 class="checklist__title">6. Четвертая неделя</h2>
		<div class="checklist__list">
			<h3 class="checklist__subtitle">Подведение итогов адаптации</h3>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-6-1" v-model="edusonChecklist">
				<span class="checkbox__label">Получена обратная связь о процессе адаптации</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-6-2" v-model="edusonChecklist">
				<span class="checkbox__label">Оценен уровень интеграции сотрудника в коллектив</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-6-3" v-model="edusonChecklist">
				<span class="checkbox__label">Выявлены предложения по улучшению процесса адаптации</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-6-4" v-model="edusonChecklist">
				<span class="checkbox__label">Проведена итоговая встреча с сотрудником</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-6-5" v-model="edusonChecklist">
				<span class="checkbox__label">Проведена встреча с руководителем (при необходимости)</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q-6-6" v-model="edusonChecklist">
				<span class="checkbox__label">Подготовлено заключение об успешном завершении адаптационного периода</span>
			</label>
		</div>

		<div class="longread longread--no-pads mt-20">
			<div class="checklist__subtitle">Рекомендации для куратора:</div>
			<ol class="order-list">
				<li>Поддерживать регулярную связь с сотрудником</li>
				<li>Создавать комфортную и доброжелательную атмосферу</li>
				<li>Помогать в решении организационных вопросов</li>
				<li>Знакомить с корпоративной культурой и традициями Компании</li>
				<li>Содействовать установлению рабочих и неформальных контактов внутри коллектива</li>
				<li>Своевременно выявлять и помогать устранять сложности адаптационного периода</li>
			</ol>
		</div>
	</section>
</template>

<script>
export default {
	name: 'CourseChecklist',

	props: {
		url: '',
	},

	data() {
		return {
			edusonChecklist: [],
		}
	},

	mounted() {
		this.edusonChecklist = JSON.parse(localStorage.edusonChecklist);
	},

	methods: {
		checkboxHandler() {
			localStorage.edusonChecklist = JSON.stringify(this.edusonChecklist);
		}
	}
}
</script>

<style>
.checklist {
	display: grid;
	grid-template-columns: 1fr;
	gap: 20px;
	padding: 24px;
	border: 1px solid var(--border-color);
	border-radius: 6px;
	background-color: var(--white);
}

.checklist__title {
	font-weight: 700;
	font-size: 20px;
}

.checklist__subtitle {
	margin-bottom: 10px;
	font-weight: 700;
}

.checklist__list {
	display: grid;
	grid-template-columns: 1fr;
	gap: 5px;
	padding-left: 28px;
}

.checklist__list .checkbox__label {
	font-size: 16px;
}
</style>
